import React, { useEffect, useState, useContext } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { StoreContext } from './contexts/StoreContext';
import { PageProvider } from './contexts/PageContext';
import Login from './components/Login/Login';
import Header from './components/Header/Header';
import RouteListener from './components/RouteListener';
import RouteGenerator from './components/RouteGenerator';
import SmartModalContainer from './components/SmartModal/SmartModalContainer';
import './App.css';

// UI тексты - константы компонента
const UI_TEXTS = {
  loading: 'Загрузка...'
};

const App = observer(() => {
  const rootStore = useContext(StoreContext);
  const { auth, models } = rootStore;
  
  // Показываем загрузку пока модели не загружены
  if (auth.isAuthenticated && models.isLoading) {
    return (
      <div className="app-loading">
        <div className="app-loading-text">{UI_TEXTS.loading}</div>
      </div>
    );
  }
  
  // Показываем Login если не авторизован
  if (!auth.isAuthenticated) {
    return <Login />;
  }
  
  // Основное приложение после авторизации
  return (
    <BrowserRouter>
      <PageProvider>
        <div className="app">
          <RouteListener />
          <Header />
          <main>
            <RouteGenerator />
          </main>
          <SmartModalContainer />
        </div>
      </PageProvider>
    </BrowserRouter>
  );
});

export default App;